(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbInternalMsgBus", [], factory);
	else if(typeof exports === 'object')
		exports["sbInternalMsgBus"] = factory();
	else
		root["sbInternalMsgBus"] = factory();
})(window, function() {
return 